import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

// No official logo supplied yet — this is a typographic wordmark placeholder.
// Swap for an <img> tag once the client's real logo file is available.
export const Logo = ({ className }) => (
  <Link to="/" data-testid="logo-home-link" className={cn("group inline-flex items-center gap-2.5", className)}>
    <span className="h-3 w-3 shrink-0 rounded-full bg-brand-purple transition-colors duration-300 group-hover:bg-live-red" />
    <span className="font-heading text-2xl uppercase leading-none tracking-tight text-white">
      Womens<span className="text-brand-purple">MatchDay</span>Live
    </span>
  </Link>
);
